import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import GrupoTarifario from '../../../contants/GrupoTarifario';
import { UserType } from '../../../contants';
import ProposalService from '../../../services/ProposalService';
import Modal from '../../Modal';
import Mask from '../../../contants/Mask';

interface IProp {
  proposal: any;
  statusActual: any;
  ProposalContract: (aceite: boolean, motivo?:string|null, paymentMethodSave?:number, paymentConditionSave?:string|null, paymentObservation?:string|null, birthDate?:string|null, maritalStatus?:number|null, fullNameOfResponsible?:string|null, documentOfResponsible?:string|null) => void;
}

const FormSelectedPayment = ({ proposal, ProposalContract}: IProp) => {
  const [ paymentMethod, setPaymentMethod ] = useState<number>(proposal.paymentType??0);
  const [ paymentCondition, setPaymentCondition ] = useState<string | null>(proposal.paymentQuota??"0");
  const [ paymentSelectValue, setPaymentSelectValue ] = useState<boolean>(false);
  const [ paymentSelectCondition, setPaymentSelectCondition ] = useState<boolean>(false);
  const [ paymentSelectConditionFinanciamento, setPaymentSelectConditionFinanciamento ] = useState<boolean>(false);
  const [ paymentObservationInfo, setPaymentObservationInfo ] = useState<string|null>(proposal.paymentObservation);
  const [ listOptionsPayment, setListOptionsPayment ] = useState<any[]>([]);
  const [ birthDate, setBirthdate ] = useState<string>(proposal.client.birthDate?? null);
  const [ errorBirthdate, setErrorBirthdate ] = useState<boolean>(false);
  const [ maritalStatus, setMaritalStatus ] = useState<string>(proposal.client.maritalStatus?? null);
  const [ errorMaritalStatus, setErrorMaritalStatus ] = useState<boolean>(false);
  const [ fullNameOfResponsible, setFullNameOfResponsible ] = useState<string>(proposal.fullNameOfResponsible ?? '');
  const [ documentOfResponsible, setDocumentOfResponsible ] = useState<string>(proposal.documentOfResponsible ?? '');
  const [ errorFullNameOfResponsible, setErrorFullNameOfResponsible ] = useState<boolean>(false);
  const [ errorDocumentOfResponsible, setErrorDocumentOfResponsible ] = useState<boolean>(false);

  useEffect(() => {
        ProposalService.getProposalOptionsPaymentAll(proposal.id).then((response:any) => {
          if(response && response.length > 0 ){
            setListOptionsPayment(response);
            return;
          }
        })
        .catch((error) => {
          Modal.show({
            title: "Erro carregar opções de pagamento",
            body: Modal.getErrorMessage(error, proposal.id),
            showCancel: true,
            showConfirm: false,
            onCancelText: "Fechar"
          });
        });

        if(paymentMethod === 3){
          CheckFinancingOptions(paymentMethod);
          setPaymentCondition(proposal.paymentQuota??"0");
        }
        if(paymentMethod === 6){
          CheckAluguelOptions(paymentMethod);
          setPaymentCondition(proposal.paymentQuota??"0");
        }
    }, []);

  const parcelOptions = Array.from({ length: 12 }, (_, i) => i + 1);

  const handleClick = ()=> {
    const isCnpj = proposal.client.userType === UserType.CNPJ;
    if (isCnpj && !fullNameOfResponsible.trim()) {
      setErrorFullNameOfResponsible(true);
      return;
    }
    if (isCnpj && documentOfResponsible.replace(/\D/g, '').length !== 11) {
      setErrorDocumentOfResponsible(true);
      return;
    }
    if(paymentMethod <= 0){
        setPaymentSelectValue(true);
        return;
    }
    if(paymentMethod === 2 && paymentCondition === "0"){
        setPaymentSelectCondition(true);
        return;
    }
    if(paymentMethod === 3 && paymentCondition === "0"){
        setPaymentSelectConditionFinanciamento(true);
        return;
    }
    if(proposal.proposalType.name === "Solar Direct" && !birthDate){
      setErrorBirthdate(true);
      return;
    }
    if(proposal.proposalType.name === "Solar Direct" && (!maritalStatus || maritalStatus === "0")){
      setErrorMaritalStatus(true);
      return;
    }
    ProposalContract(true,null,paymentMethod,paymentCondition,paymentObservationInfo, birthDate,Number(maritalStatus??"0"), isCnpj ? fullNameOfResponsible.trim() : null, isCnpj ? documentOfResponsible : null);
  }

 const CheckProposalSolarAluguel = () => {
    if(listOptionsPayment.length > 0){
      const hasAluguel = listOptionsPayment.some((item: any) => item.optionType === 2);
      return hasAluguel;
    }
    if (
      proposal?.proposalType?.name === "Solar Direct" &&
      proposal?.grupoTarifario === GrupoTarifario.GrupoB
    ) {
      const hasKitHibrido = proposal?.proposalItems?.some((item: any) =>
        item?.product?.name?.toLowerCase().startsWith("kit hibrido")
      );

      if (!hasKitHibrido) {
        const isCPF = proposal?.client?.userType === UserType.CPF;
        const isCNPJ = proposal?.client?.userType === UserType.CNPJ;
        const value = proposal?.cashValue ?? 0;

        if ( (isCPF && value <= 70000) || (isCNPJ && value <= 250000) ) {
          return true;
        }
      }
    }

    return false;
  };
  function CheckFinancingOptions(paymentMethodSelected: number) {
    if (paymentMethodSelected === 3) {  
      if(proposal.proposalType.name === "Solar Direct"){
        if (listOptionsPayment?.some((item: any) => item.optionType === 1)) {
          return;
        }
        setPaymentSelectConditionFinanciamento(false);
          
      }
    }
  }
  function CheckAluguelOptions(paymentMethodSelected: number) {
    if (paymentMethodSelected === 6) {  
      if(proposal.proposalType.name === "Solar Direct"){
        if (listOptionsPayment?.some((item: any) => item.optionType === 2)) {
          return;
        }
        setPaymentSelectConditionFinanciamento(false);
         
      }
    }
  }

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <label>Forma de Pagamento:</label>
        <select
          value={paymentMethod.toString()}
          onChange={(e:any) => {
            setPaymentSelectValue(false);
            setPaymentCondition(proposal.paymentQuota??0);
            setPaymentMethod(Number(e.target.value));
            CheckFinancingOptions(Number(e.target.value));
            CheckAluguelOptions(Number(e.target.value));
          }}
          style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
        >
          <option value="0">Selecione</option>
          {
            CheckProposalSolarAluguel() &&
              <option value="6">Ezee Solar Aluguel</option>
          }
          <option value="3">Financiamento</option>
          <option value="1">PIX</option>
          <option value="2">Cartão de Crédito</option>
          <option value="5">Negociação</option>
        </select>
        {
            (paymentSelectValue) &&
                <span style={{color:'red'}}>Selecione uma forma de pagamento!</span>
        }
      </div>

      {paymentMethod === 2 && (
        <div>
          <label>Condição de Pagamento:</label>
          <select
            value={paymentCondition??"0"}
            onChange={(e:any) => {
                setPaymentSelectCondition(false);
                setPaymentCondition(e.target.value);
            }}
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          >
            <option value="0">Selecione</option>
            {parcelOptions.map((opt, index) => (
              <option key={index} value={opt}>
                {opt}x
              </option>
            ))}
          </select>
            {
                (paymentSelectCondition) &&
                    <span style={{color:'red'}}>Selecione a condição de Pagamento!</span>
            }
        </div>
      )}

      {paymentMethod === 3 && (
        <div>
          <label>Opções de financiamento:</label>
          <select
            value={paymentCondition??"0"}
            onChange={(e:any) => {
                setPaymentSelectCondition(false);
                setPaymentCondition(e.target.value);
            }}
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          >
            <option value="0">Selecione</option>
            {listOptionsPayment
              ?.filter((item: any) => item.optionType === 1)
              .map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
          </select>
            {
                (paymentSelectConditionFinanciamento) &&
                    <span style={{color:'red'}}>Selecione a condição de Pagamento!</span>
            }
        </div>
      )}

      {paymentMethod === 6 && (
        <div>
          <label>Opções de aluguel:</label>
          <select
            value={paymentCondition??"0"}
            onChange={(e:any) => {
                setPaymentSelectCondition(false);
                setPaymentCondition(e.target.value);
            }}
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          >
            <option value="0">Selecione</option>
            {listOptionsPayment
            ?.filter((item: any) => item.optionType === 2)
            .map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
            {
                (paymentSelectConditionFinanciamento) &&
                    <span style={{color:'red'}}>Selecione a condição de Pagamento!</span>
            }
        </div>
      )}
      {
        (proposal.proposalType.name === "Solar Direct" && !proposal.client.birthDate) &&
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label htmlFor="documentos"> Data de Nascimento {(proposal.client.userType === 2) ? "do representante!" : ""} (Exemplo: 01/01/1990 ) (*)</label>
          <input
            type="text"
            id="birthdate"
            name="birthdate"
            maxLength={10}
            style={{maxWidth: 139}}
            placeholder='00/00/2000'
            value={Mask.date(birthDate)?? ''}
            onChange={(e) => {
              setErrorBirthdate(false);
              setBirthdate(e.target.value);
            }}
            className={'form-control'}
          />
          {errorBirthdate && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Informe o estado civil{(proposal.client.userType === 2)? " do responsável!":"!"}</span>}
        </div>
      }
      
      {
        (proposal.proposalType.name === "Solar Direct" && (!proposal.client.maritalStatus || (proposal?.client?.maritalStatus??"0") === "0")) &&
        <div className="form-group" style={{ marginBottom: 10 }}>
          <select
            id="tipoEstadoCivil"
            name="tipoEstadoCivil"
            value={proposal.client.maritalStatus}
            onChange={(e) => {
              setErrorMaritalStatus(false);
              setMaritalStatus(e.target.value);
             }}
            className={'form-control'}
          >
            <option value="0">Selecione o Estado Civil</option>
            <option value="1">Solteiro(a)</option>
            <option value="2">Casado(a)</option>
            <option value="3">Divorciado(a)</option>
            <option value="4">Viúvo(a)</option>
            <option value="5">União Estável</option>
            <option value="6">Outro</option>
          </select>
          {errorMaritalStatus && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Informe o estado civil{(proposal.client.userType === 2)? " do responsável!":"!"}</span>}
        </div>
      }
      {
        proposal.client.userType === UserType.CNPJ &&
        <>
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label htmlFor="fullNameOfResponsible">Nome do Responsável (*)</label>
            <input
              type="text"
              id="fullNameOfResponsible"
              name="fullNameOfResponsible"
              value={fullNameOfResponsible}
              onChange={(e) => {
                setErrorFullNameOfResponsible(false);
                setFullNameOfResponsible(e.target.value);
              }}
              className={`form-control ${errorFullNameOfResponsible ? 'is-invalid' : ''}`}
            />
            {errorFullNameOfResponsible && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Informe o nome do responsável!</span>}
          </div>
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label htmlFor="documentOfResponsible">CPF do Responsável (*)</label>
            <input
              type="text"
              id="documentOfResponsible"
              name="documentOfResponsible"
              maxLength={14}
              value={Mask.cpf(documentOfResponsible) ?? ''}
              onChange={(e) => {
                setErrorDocumentOfResponsible(false);
                setDocumentOfResponsible(e.target.value);
              }}
              className={`form-control ${errorDocumentOfResponsible ? 'is-invalid' : ''}`}
            />
            {errorDocumentOfResponsible && <span className="error-message" style={{ color: '#f52020', fontSize: 10 }}>Informe um CPF válido para o responsável!</span>}
          </div>
        </>
      }
      <div style={{ marginBottom: '1rem',marginTop: '0.25rem' }}>
          <label style={{display:'block'}}>Observação:</label>
          <textarea id="observacao" className='control-form' style={{maxWidth:'100%', margin:'0 auto', padding:4}} onChange={(e)=>{setPaymentObservationInfo(e.target.value)}} rows={2} cols={100} placeholder="Observações sobre o pagamento..." >{paymentObservationInfo}</textarea>
      </div>
        <div style={{ paddingTop: 15, paddingBottom: 15, display: 'flex', justifyContent: 'flex-end' }}>
            <Button className="btn btn-danger btnNO" style={{marginRight:10, cursor:'pointer'}} onClick={() => {window.location.reload()}}> Cancelar</Button>
            <Button className="btn btn-success btnOk" style={{cursor:'pointer'}} onClick={() => handleClick()}> Aceitar</Button>
      </div>
    </>
  );
};

export default FormSelectedPayment;
